import { exportPDF } from "@api/stores/employeeCosts/exportPDF/path";
import { stats } from "@api/stores/employeeCosts/stats/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/employee-costs/`;
const pathById = `${pathBase}:costId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const employeeCosts = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  patch: apiPathFunc(pathById),
  delete: apiPathFunc(pathById),
  stats,
  exportPDF,
};
